import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'

const KIOSK_URL = 'https://pos-frontend-kappa-two.vercel.app/?mode=kiosk'
const API_URL = 'https://pineapple-pos-backend-production.up.railway.app/api'
const LOCATION_ID = 'b2c3d4e5-f6a7-8901-bcde-f12345678901'
const IMG_BASE = 'https://pineapple-pos-backend-production.up.railway.app/uploads/menu'

// Fallback burger data in case API doesn't load
const FALLBACK_BURGERS = [
  { name: 'Hanky Panky (B.Y.O)', description: 'BUILD YOUR OWN BURGER. Starts with 2 patties and a bun.', price: 9, image: `${IMG_BASE}/hanky-panky.jpg` },
  { name: 'BACON JAM', description: 'Bacon Jam, Gruyere, Caramelized onions, Roasted garlic mayo', price: 15, image: `${IMG_BASE}/bacon-jam.jpeg` },
  { name: "TOMORROW'S REGRET", description: 'Fried egg, Lettuce, Tomato, Sautéed peppers, Blue Cheese, Blackened seasoning', price: 16, image: `${IMG_BASE}/tomorrows-regret.jpg` },
  { name: 'DELIRIUM', description: 'Black bean and quinoa patty, Sharp cheddar, Pickles, Spinach, Avocado', price: 17, image: `${IMG_BASE}/delirium.jpg` },
]

// Happy Endings - Dessert Pancakes (images to be added later)
const HAPPY_ENDINGS = [
  { name: 'SIN', description: 'Cinnamon Swirl, cinnamon butter, caramel, Bacon bits', image: null },
  { name: 'PILLOW TALK', description: 'Strawberries, whipped cream, caramel', image: null },
  { name: 'BLIND DATE', description: 'Choose Sweet or Savory, chef\'s choice after that!', image: null },
  { name: 'HOT MESS', description: 'Spicy Black beans, fried egg, maple syrup, ham', image: null },
]

export default function Home() {
  const [featuredItems, setFeaturedItems] = useState(FALLBACK_BURGERS)
  const [heroImage, setHeroImage] = useState(FALLBACK_BURGERS[0])

  useEffect(() => {
    // Fetch menu to get burger images (updates fallback if API works)
    const fetchMenu = async () => {
      try {
        const res = await fetch(`${API_URL}/menu/full?locationId=${LOCATION_ID}`)
        if (res.ok) {
          const data = await res.json()
          const burgerItems = data.items?.burgers || []
          const itemsWithImages = burgerItems.filter(item => item.image && item.available)

          if (itemsWithImages.length > 0) {
            setHeroImage(itemsWithImages[0])
            setFeaturedItems(itemsWithImages.slice(0, 4))
          }
        }
      } catch (err) {
        console.log('Using fallback burger images')
      }
    }
    fetchMenu()
  }, [])

  // ============================================
  // CLOSED FOR REPAIRS - Remove this when ready to reopen
  // ============================================
  const CLOSED_FOR_REPAIRS = false

  return (
    <div className="flex flex-col">
      {/* Closed Banner */}
      {CLOSED_FOR_REPAIRS && (
        <div className="bg-gradient-to-r from-red-900 via-red-800 to-red-900 text-white py-6 px-4 text-center">
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <span className="font-bold text-xl">We are currently closed</span>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="bg-black">
        <div className="max-w-5xl mx-auto px-2 text-center">
          {/* Logo */}
          <img
            src="https://pineapple-pos-backend-production.up.railway.app/uploads/menu/hanky-panky-logo-transparent.png"
            alt="Hanky Panky Burgers"
            className="w-[400px] md:w-[500px] lg:w-[600px] mx-auto drop-shadow-2xl"
            onError={(e) => { e.target.style.display = 'none' }}
          />

          <p className="text-xl md:text-2xl max-w-2xl mx-auto my-6">
            <span className="text-gray-300">Late night smash burgers in Fayetteville. </span>
            <span className="text-yellow-500 font-bold">House ground blend of local meats for our signature flavor. </span>
            <span className="text-gray-300">Crispy edges, juicy centers, and flavors that hit different after dark.</span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pb-8">
            <a
              href={KIOSK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-lg rounded-xl transition-all hover:scale-105 shadow-lg shadow-yellow-500/25"
            >
              Order Now
            </a>
            <Link
              to="/menu"
              className="px-8 py-4 border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold text-lg rounded-xl transition-all"
            >
              View Menu
            </Link>
          </div>
        </div>

      </section>

      {/* Featured Burgers Section */}
      {featuredItems.length > 0 && (
        <section className="py-20 bg-zinc-900">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
              Our <span className="text-yellow-500">Burgers</span>
            </h2>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featuredItems.map((item, index) => (
                <a
                  key={index}
                  href={KIOSK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-black rounded-2xl overflow-hidden border-2 border-yellow-500/30 hover:border-yellow-500 transition-all"
                >
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-yellow-500 font-bold text-lg">{item.name}</h3>
                    <p className="text-gray-400 text-sm mt-1 line-clamp-2">{item.description}</p>
                    <p className="text-white font-bold mt-2">${Number(item.price).toFixed(2)}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="text-center mt-10">
              <a
                href={KIOSK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-yellow-500 hover:text-yellow-400 font-semibold text-lg"
              >
                See Full Menu
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          </div>
        </section>
      )}

      {/* Happy Endings - Dessert Pancakes */}
      <section className="py-20 bg-black">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">
            Happy <span className="text-yellow-500">Endings</span>
          </h2>
          <p className="text-center text-gray-400 mb-12">Late night pancakes done right</p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {HAPPY_ENDINGS.map((item, index) => (
              <a
                key={index}
                href={KIOSK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-zinc-900 rounded-2xl overflow-hidden border-2 border-yellow-500/30 hover:border-yellow-500 transition-all"
              >
                <div className="aspect-square overflow-hidden bg-gradient-to-br from-yellow-500/20 to-yellow-600/5">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <span className="text-yellow-500/30 text-6xl font-bold">HP</span>
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-yellow-500 font-bold text-lg">{item.name}</h3>
                  <p className="text-gray-400 text-sm mt-1 line-clamp-2">{item.description}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-20 bg-black">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Smashed to <span className="text-yellow-500">Perfection</span>
              </h2>
              <p className="text-gray-300 mb-6 text-lg">
                At Hanky Panky, we take our smash burgers seriously. Each patty is pressed
                hot on the griddle, creating those crispy, caramelized edges that make
                a smash burger unforgettable.
              </p>
              <p className="text-gray-400 mb-8">
                Operating late night out of Prelude Breakfast Bar, we're here when you
                need us most. Quality ingredients, no shortcuts, just damn good burgers.
              </p>
              <Link
                to="/about"
                className="inline-flex items-center text-yellow-500 hover:text-yellow-400 font-semibold"
              >
                Learn more about us
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
            <div className="relative">
              {heroImage ? (
                <div className="aspect-square rounded-3xl overflow-hidden border-2 border-yellow-500/30">
                  <img
                    src={heroImage.image}
                    alt={heroImage.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div className="aspect-square bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 rounded-3xl border border-yellow-500/30" />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-zinc-900">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
            Why Choose <span className="text-yellow-500">Hanky Panky?</span>
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              icon={<FireIcon />}
              title="Smashed Fresh"
              description="Every burger is smashed to order on a hot griddle for maximum flavor."
            />
            <FeatureCard
              icon={<MoonIcon />}
              title="Late Night"
              description="Open late when you need it most. Perfect for after-hours cravings."
            />
            <FeatureCard
              icon={<BoltIcon />}
              title="Quick Pickup"
              description="Order online and pick up fast. No waiting around."
            />
            <FeatureCard
              icon={<PhoneIcon />}
              title="Easy Ordering"
              description="Order from your phone and get a text when your food is ready."
            />
            <FeatureCard
              icon={<StarIcon />}
              title="Quality Ingredients"
              description="Fresh beef, real cheese, and toppings that actually matter."
            />
            <FeatureCard
              icon={<LocationIcon />}
              title="Fayetteville Local"
              description="Proudly serving the Fayetteville community late into the night."
            />
          </div>
        </div>
      </section>

      {/* Location & Hours */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            Find <span className="text-yellow-500">Us</span>
          </h2>

          <div className="grid sm:grid-cols-2 gap-8">
            <div className="bg-zinc-900 rounded-2xl p-8 border border-yellow-500/20">
              <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <LocationIcon className="w-6 h-6 text-yellow-500" />
              </div>
              <h3 className="text-xl font-bold text-yellow-500 mb-4">Location</h3>
              <p className="text-gray-300 mb-1">Inside Prelude Breakfast Bar</p>
              <p className="text-gray-300 mb-1">509 W. Spring Street, Ste 210</p>
              <p className="text-gray-400">Fayetteville, AR</p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=509+W+Spring+Street+Fayetteville+AR"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-4 text-yellow-500 hover:text-yellow-400 font-semibold"
              >
                Get Directions
              </a>
            </div>

            <div className="bg-zinc-900 rounded-2xl p-8 border border-yellow-500/20">
              <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <MoonIcon className="w-6 h-6 text-yellow-500" />
              </div>
              <h3 className="text-xl font-bold text-yellow-500 mb-4">Hours</h3>
              <div className="text-gray-300 space-y-1">
                <p className="text-lg font-semibold text-white">Thursday - Saturday</p>
                <p className="text-yellow-500 font-semibold text-xl">10pm - 3am</p>
                <p className="text-gray-400 text-sm mt-2">Inside Prelude Breakfast Bar</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-b from-zinc-900 to-black">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready for a <span className="text-yellow-500">Smash Burger?</span>
          </h2>
          <p className="text-gray-300 mb-8 text-lg">
            Skip the line and order ahead for quick pickup.
          </p>
          <a
            href={KIOSK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-10 py-5 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-xl rounded-xl transition-all hover:scale-105 shadow-lg shadow-yellow-500/25"
          >
            Order Now
          </a>
        </div>
      </section>
    </div>
  )
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-black rounded-2xl p-6 border border-yellow-500/20 hover:border-yellow-500/40 transition-colors">
      <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center text-yellow-500 mb-4">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-white mb-2">{title}</h3>
      <p className="text-gray-400 text-sm">{description}</p>
    </div>
  )
}

// Icons
function FireIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
    </svg>
  )
}

function MoonIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
    </svg>
  )
}

function BoltIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  )
}

function PhoneIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  )
}

function StarIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
  )
}

function LocationIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  )
}
